import { Grid } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../components";
import "./LogOut.scss";

const LogOut = () => {
  const navigate = useNavigate();

  return (
    <div className="mainContaa">
      <Grid className="backgroundLoginMain">
        <Grid.Column computer={16} tablet={16} mobile={16}>
          <span className="welcomeTxt">Successfully Logged Out!</span>
        </Grid.Column>
        <Grid.Column style={{ paddingTop: "0px" }} computer={16} tablet={16} mobile={16}>
          <span className="secondaryTxt">You have been logged out successfully.</span>
        </Grid.Column>
        <Grid.Column style={{ paddingTop: "15px" }} computer={16} tablet={16} mobile={16}>
          <CustomButton
            theme="green"
            title="Go to Login"
            customButtonStyle={"customBtnn"}
            onClick={() => {
              navigate("/auth");
            }}
          />
        </Grid.Column>
      </Grid>
    </div>
  );
};
export default LogOut;
